// extracted by css-extract-rspack-plugin
export default {"cls1":"DownloadOptionCard-cls1_tbE","cls2":"DownloadOptionCard-cls2_elF DownloadOptionCard-cls1_tbE"};